import React, { useState } from 'react';
import {
 Button,
 Modal,
 ModalOverlay,
 ModalContent,
 Text,
 Flex,
 useToast,
 Box,
} from '@chakra-ui/react';
import baseService from '../../services/base';
import { SuccessModal } from '../Modals';

export default function SubmitAnswersButton({
 certificationStatusId,
 mutate,
 isEnabled,
 selectedCertification,
 companyId,
 userId,
 idCompanyGroup,
}) {
 const [isSubmitting, setIsSubmitting] = useState(false);
 const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
 const [isSuccessOpen, setIsSuccessOpen] = useState(false);
 const toast = useToast();

 const handleSendResponses = async () => {
  try {
    setIsSubmitting(true);
      
    if (certificationStatusId) {
      await baseService.patch(
        `/certificate-status-control/${certificationStatusId}`,
        {
          // EG-24: fluxo atual é auditoria (substitui avaliação). userId registra
          // o papel no histórico.
          status: 'EM AUDITORIA',
          motive: 'enviado pelo responsável',
          userId,
        }
      );
    } else {
      const response = await baseService.post(
        `certificate-status-control?certificateId=${selectedCertification}&userId=${userId}&roleId=${3}&companyId=${companyId}&companyGroupId=${idCompanyGroup}`
      );

      if (response?.data?.id) {
        await baseService.patch(
          `/certificate-status-control/${response.data.id}`,
          {
            status: 'EM AUDITORIA',
            motive: 'enviado pelo responsável',
            userId,
          }
        );
      } else {
        throw new Error('ID do certificado não encontrado na resposta');
      }
    }

    setIsConfirmationOpen(false);
    setIsSuccessOpen(true);
  } catch (error) {
    toast({
      title: 'Erro ao enviar respostas',
      description: error.response?.data?.message || error.message || 'Tente novamente mais tarde',
      status: 'error',
    });
  } finally {
    setIsSubmitting(false);
  }
};

 const handleClose = () => {
  setIsSuccessOpen(false);
  mutate();
 };

 return (
  <>
   <Button
    variant='primary'
    width='190px'
    height='51px'
    onClick={() => setIsConfirmationOpen(true)}
    isDisabled={!isEnabled}
   >
    Enviar respostas
   </Button>

   {/* Modal de Confirmação */}
   <Modal
    isOpen={isConfirmationOpen}
    isCentered
    onClose={() => setIsConfirmationOpen(false)}
   >
    <ModalOverlay />
    <ModalContent
     p='0'
     maxW='484px'
     borderRadius='10px'
     overflow='hidden'
     textAlign='center'
    >
     <Box p='6'>
      <Text
       fontSize={['14px', '20px']}
       color='orange.200'
       fontWeight={600}
       lineHeight='normal'
       mb='12px'
      >
       Atenção!
      </Text>
      <Text fontSize='28px' fontWeight={700} lineHeight='32.87px' mb='18px'>
       Deseja mesmo enviar as respostas para auditoria?
      </Text>
      <Text fontSize='18px' lineHeight='24px' color='#5C6066'>
       Ao confirmar, não será possível mais editar suas respostas ou incluir evidências.
      </Text>
     </Box>
     <Flex h='59px'>
      <Button
       border='none'
       bg='#EA582B'
       color='white'
       flex={1}
       h='59px'
       borderRadius={0}
       onClick={() => setIsConfirmationOpen(false)}
       _hover={{
        bg: '#EA582B',
        opacity: '0.7',
       }}
      >
       Não, voltar
      </Button>
      <Button
       variant='primary'
       flex={1}
       h='59px'
       borderRadius={0}
       onClick={handleSendResponses}
       isLoading={isSubmitting}
      >
       Sim, enviar
      </Button>
     </Flex>
    </ModalContent>
   </Modal>

   {/* Modal de Sucesso */}
   <SuccessModal
    isOpen={isSuccessOpen}
    onClose={handleClose}
    title='Questionário enviado para auditoria com sucesso!'
   />
  </>
 );
}
